import type { CmsProps } from '../../types/cms'
import FormattedImage from '../FormattedImage'
import { resizeImage } from '../../utils/resizeImage'

const TechnologyLogo = ({ logo, mobile = false }: CmsProps) => {
  const dimensions = size =>
    resizeImage(logo.data.attributes[size]) * (mobile ? 0.75 : 1)

  return (
    <FormattedImage
      image={logo}
      width={dimensions('width')}
      height={dimensions('height')}
      layout="fixed"
      priority
    />
  )
}

export default TechnologyLogo
